import React, { useEffect, useRef } from "react";
import { withGesture } from "react-with-gesture";

function Slide({
  image,
  slide,
  offsetRadius,
  index,
  moveSlide,
  onImageClick,
  delta,
  down,
}) {
  const offsetFromMiddle = index - offsetRadius;
  const isActive = offsetFromMiddle === 0;
  const lastSnap = useRef(0);

  useEffect(() => {
    if (!isActive || !down || !delta) return;
    const now = Date.now();
    if (now - lastSnap.current < 300) return;
    if (delta[1] > 40) {
      lastSnap.current = now;
      moveSlide(-1);
    } else if (delta[1] < -40) {
      lastSnap.current = now;
      moveSlide(1);
    }
  }, [isActive, down, delta, moveSlide]);

  return (
    <div
      className="carousel-slide-container itemInner w-[300px] sm:w-[280px] md:w-[360px] xl:w-[450px]"
      data-offset={String(offsetFromMiddle)}
      data-active={isActive ? "true" : "false"}
    >
      <div
        className={`carousel-slide-card item w-[360px] sm:w-[280px] md:w-[360px] xl:w-[450px] ${
          isActive ? "active" : ""
        }`}
        onClick={() => {
          if (offsetFromMiddle !== 0) {
            moveSlide(offsetFromMiddle);
          }
        }}
      >
        <img
          src={image}
          alt=""
          className="cursor-pointer relative z-10 pointer-events-auto"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isActive && onImageClick && slide?.quiz) {
              onImageClick(slide.quiz);
            }
          }}
        />
      </div>
    </div>
  );
}

export default withGesture()(Slide);
